let checkPath;

let stagingURL = window.location.hostname === "pswstaging.synccare.com.au";
let localhostURL = window.location.hostname === "localhost";

export default checkPath = stagingURL || localhostURL;